import React, { useState, useEffect, useRef } from "react";

const PerformanceMonitor = ({ enabled = false }) => {
  const [fps, setFps] = useState(0);
  const [memoryUsage, setMemoryUsage] = useState(null);
  const frameCount = useRef(0);
  const lastTime = useRef(performance.now());
  const animationId = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    const updatePerformanceMetrics = () => {
      frameCount.current++;
      const currentTime = performance.now();

      if (currentTime - lastTime.current >= 1000) {
        const currentFps = Math.round(
          (frameCount.current * 1000) / (currentTime - lastTime.current)
        );
        setFps(currentFps);
        frameCount.current = 0;
        lastTime.current = currentTime;

        // Memory usage (if available)
        if (performance.memory) {
          setMemoryUsage({
            used: Math.round(performance.memory.usedJSHeapSize / 1024 / 1024),
            total: Math.round(performance.memory.totalJSHeapSize / 1024 / 1024),
            limit: Math.round(performance.memory.jsHeapSizeLimit / 1024 / 1024),
          });
        }
      }

      animationId.current = requestAnimationFrame(updatePerformanceMetrics);
    };

    animationId.current = requestAnimationFrame(updatePerformanceMetrics);

    return () => {
      if (animationId.current) {
        cancelAnimationFrame(animationId.current);
      }
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "10px",
        right: "10px",
        background: "rgba(0,0,0,0.8)",
        color: "white",
        padding: "10px",
        borderRadius: "5px",
        fontSize: "12px",
        zIndex: 9999,
        fontFamily: "monospace",
      }}
    >
      <div>FPS: {fps}</div>
      {memoryUsage && (
        <div>
          Memory: {memoryUsage.used}MB / {memoryUsage.total}MB
        </div>
      )}
    </div>
  );
};

export default PerformanceMonitor;
